export default __webpack_public_path__ + "static/media/downRow.9f195156.svg";